import Portal from '@ixigo/iui/Portal';
import { useRouterState } from '@tanstack/react-router';
import { LazyUi } from '../lazy-ui';
import LinearProgressBar from './LinearProgressBar';

export default function LinearProgress() {
	const isPending = useRouterState({
		select: (state) => {
			return state.status === 'pending';
		},
	});

	return <LazyUi loading={isPending} fallback={<Fallback />} />;
}

function Fallback() {
	return (
		<Portal>
			<LinearProgressBar className="fixed top-0 w-full h-1 z-[1301] text-brand bg-brand-subtle" />
		</Portal>
	);
}
